export default __webpack_public_path__ + "static/media/kyc-verified-icon.f51c7280.svg";